import { CompanyAPI } from '@api/buser-http-client';

const getContract = () => CompanyAPI.getContract()
  .then((data) => data)
  .catch((error) => Promise.reject(error.response?.data || error.response));

export { getContract };
